import Config from '@/config'
import { PAYMENT_METHODS } from '@/constants/payment-methods'
import PAYMENT_TYPES from '@/constants/payment-types'
import { getSupportedPaymentMethods } from '@/utils/country-config'
import { isEmbedded } from '@/utils/iframe-support'

const APPLE_PAY_SUPPORTED_PAYMENT_TYPES = [
  PAYMENT_TYPES.PAY_BY_INSTALMENTS,
  PAYMENT_TYPES.PAY_NOW,
]

const isApplePayAvailable = (countryCode, paymentType) => {
  try {
    // Don't support Apple Pay for iframe solution
    if (isEmbedded()) {
      return false
    }

    const supportedPaymentMethods =
      getSupportedPaymentMethods(countryCode) || []
    // Config support Apple Pay by country
    const isSupportedByPaymentMethod = supportedPaymentMethods.includes(
      PAYMENT_METHODS.applePay
    )
    // Config support Apple Pay by payment type or don't need to check payment type
    const isSupportedByPaymentType =
      APPLE_PAY_SUPPORTED_PAYMENT_TYPES.includes(paymentType) || !paymentType

    // Ignore Apple Pay if it is not accepted by country and payment type
    if (!isSupportedByPaymentMethod || !isSupportedByPaymentType) {
      return false
    }

    if (window.ApplePaySession) {
      // ref official Apple Pay checking
      // https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/checking_for_apple_pay_availability
      // The Apple Pay JS API is available.
      return (
        window.ApplePaySession.canMakePayments() &&
        window.ApplePaySession.supportsVersion(Config.applepayVersion)
      )
    }

    return false
  } catch (_) {
    return false
  }
}

export { isApplePayAvailable }
